const favoriteButtonSizes = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
};

export { favoriteButtonSizes as f };
